import {Component, ElementRef, HostListener, Input, OnChanges} from '@angular/core';

@Component({
    selector: 'relation-list',
    templateUrl: './relation-list.component.html',
    styleUrls: ['./relation-list.component.scss']
})
export class RelationListComponent implements OnChanges {
    @Input() items: Array<any> = [];
    @Input() values: Array<any> = [];
    @Input() keyTitle: string = 'title';
    @Input() keyId: string = 'id';
    @Input() other: string = '';

    public data: Array<any> = [];
    public isShow: boolean = false;

    private _value: string;

    constructor(private elementRef: ElementRef) {
    }

    ngOnChanges() {
        this.propagateChange();
    }

    set value(val) {
        this._value = val ? val : this.other;
    }

    get value(): string {
        return this._value;
    }

    propagateChange() {
        this.data = [];
        if (this.items && this.items.length && this.values && this.values.length) {
            this.items.forEach(item => {
                if (this.values.some(v => v == item[this.keyId])) {
                    /*
                     usage of "some" function is here because values sometimes are string[] and items have number[]
                     and "==" comparison helps with that situation
                    */
                    this.data.push(item[this.keyTitle]);
                }
            });
        }
        this.value = this.data ? this.data.join(', ') : '';
    }

    toggleDetails() {
        if (this.data.length) {
            this.isShow = !this.isShow;
        }
    }

    @HostListener('document:click', ['$event.target'])
    private hide(targetElement: HTMLElement): void {
        if (!this.elementRef.nativeElement.contains(targetElement)) {
            this.isShow = false;
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/relation-list/relation-list.component.ts